import React from "react";
import Dashboard from "../../components/Dashboard/Dashboard";

function DashboardUser() {
	return (
		<>
			<Dashboard links={true} />
		</>
	);
}

export default DashboardUser;
